export var JoinedConferenceState;
(function (JoinedConferenceState) {
    JoinedConferenceState["JOINING"] = "JOINING";
    JoinedConferenceState["JOINED"] = "JOINED";
    JoinedConferenceState["LEAVING"] = "LEAVING";
    JoinedConferenceState["ENDING"] = "ENDING";
})(JoinedConferenceState || (JoinedConferenceState = {}));
export var ConferenceEventType;
(function (ConferenceEventType) {
    ConferenceEventType["CONFERENCE_JOINED"] = "ConferenceJoinedEvent";
    ConferenceEventType["CONFERENCE_PARTICIPANT_METADATA_UPDATED"] = "ConferenceParticipantMetadataUpdatedEvent";
    ConferenceEventType["CONFERENCE_LEFT"] = "ConferenceLeftEvent";
    ConferenceEventType["CONFERENCE_PARTICIPANT_STATE_CHANGED_EVENT"] = "ConferenceParticipantStateChangedEvent";
    ConferenceEventType["CONFERENCE_STREAM_PUBLISHED"] = "ConferenceStreamPublishedEvent";
    ConferenceEventType["CONFERENCE_STREAM_METADATA_UPDATED"] = "ConferenceStreamMetadataUpdatedEvent";
    ConferenceEventType["CONFERENCE_STREAM_UNPUBLISHED"] = "ConferenceStreamUnpublishedEvent";
    ConferenceEventType["CONFERENCE_ENDED"] = "ConferenceEndedEvent";
    ConferenceEventType["CONFERENCE_METADATA_UPDATE"] = "ConferenceMetadataUpdatedEvent";
    ConferenceEventType["CONFERENCE_NETWORK_INDICATOR"] = "ConferenceNetworkIndicatorUpdatedEvent";
})(ConferenceEventType || (ConferenceEventType = {}));
export var ConferenceStreamType;
(function (ConferenceStreamType) {
    ConferenceStreamType["MIC"] = "mic";
    ConferenceStreamType["CAM"] = "cam";
    ConferenceStreamType["MIC_AND_CAM"] = "mic_and_cam";
    ConferenceStreamType["SCREEN"] = "screen";
    ConferenceStreamType["UNKNOWN"] = "unknown";
})(ConferenceStreamType || (ConferenceStreamType = {}));
export var ConferenceMode;
(function (ConferenceMode) {
    ConferenceMode["ROUTER"] = "router";
    ConferenceMode["P2P"] = "p2p";
    ConferenceMode["UNKNOWN"] = "unknown";
})(ConferenceMode || (ConferenceMode = {}));
export var EndpointState;
(function (EndpointState) {
    EndpointState["HEALTHY"] = "HEALTHY";
    EndpointState["SICK"] = "SICK";
    EndpointState["UNKNOWN"] = "UNKNOWN";
})(EndpointState || (EndpointState = {}));
